// extracted by mini-css-extract-plugin
module.exports = {"rotation":"LandingTemplate_rotation__zDZ3G"};